import { render, staticRenderFns } from "./AdicionarDescontoDialog.vue?vue&type=template&id=fbfd8e48&"
import script from "./AdicionarDescontoDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarDescontoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports